import { handleActions } from 'redux-actions'
import { fromJS } from 'immutable'
import * as Actions from 'actions/persona_library'
import * as AppActions from 'actions/app'

export const initialState = fromJS({
  personas: []
})

export default handleActions({
  [Actions.setPersonas]: (state, { payload }) => state.set('personas', fromJS(payload)),
  [Actions.createPersonaSuccess]: (state, { payload }) => state.set('personas', state.get('personas').unshift(fromJS(payload))),
  [Actions.updatePersonaSuccess]: (state, { payload }) => {
    const updatedPersonas = state.get('personas').map(persona => (persona.get('id') === payload.id ? fromJS(payload) : persona))

    return state
      .set('personas', updatedPersonas)
  },
  [AppActions.resetState]: () => initialState
}, initialState)
